import React, { useEffect } from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  Divider,
  FormControlLabel,
  FormLabel,
  Modal,
  Radio,
  RadioGroup,
  Typography
} from '@material-ui/core';
import HelpIcon from '@material-ui/icons/HelpOutlined';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import CancelButton from '../atoms/CancelButton';
import ConfirmButton from '../atoms/ConfirmButton';
import ConfirmDialog from './ConfirmDialog';
import ProgressDialog from './ProgressDialog';
import { EDIT_GROUP_GOCHI_KID_FLAG_SHOP_SUCCESS } from '../../actions/Groups';
import ConfirmGochiKidFlagGroupDialog from './ConfirmGochiKidFlagGroupDialog';
import HelpQrUserKidShopDialog from './HelpQrUserKidShopDialog';

const styles = {
  modal: {
    maxWidth: 880,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  contentContainer: {
    padding: 40,
    backgroundColor: '#fff',
    borderRadius: 4
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 5
  },
  description: {
    display: 'block',
    fontSize: 18,
    marginBottom: 20
  },
  fs14: {
    fontSize: 14
  },
  radioGroup: {
    marginBottom: 10
  },
  buttonContainer: {
    marginTop: 15
  },
  paper: {
    padding: 20,
    marginTop: 15
  },
  detailTable: {
    width: '100%',
    padding: 15
  },
  tableCellItem: {
    backgroundColor: '#D9D9D9',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 10,
    // whiteSpace: 'nowrap',
    width: 240,
    border: 'none'
  },
  tableCellData: {
    padding: '12px 10px',
    fontSize: 12,
    whiteSpace: 'pre-line',
    border: 'none'
  },
  textHelpTitle: {
    color: '#808080',
    fontSize: '14px',
    fontWeight: 700,
    verticalAlign: 'middle',
    cursor: 'default'
  },
  buttonHelp: {
    justifyContent: 'flex-start',
    backgroundColor: 'transparent',
    minWidth: 'fit-content',
    border: 'none',
    verticalAlign: 'middle',
    cursor: 'pointer'
  },
  iconHelpEx: {
    color: 'gray !important',
    width: '20px',
    height: '20px'
  }
};

const enhance = compose(
  connect(
    state => ({
      shops: state.shops.shops
    }),
    () => ({})
  ),
  withState('openEditProgress', 'updateOpenEditProgress', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('openConfirmGochiKidFlag', 'updateOpenConfirmGochiKidFlag', false),
  withState('openHelpQrUserKid', 'setOpenHelpQrUserKid', false),
  withState('loading', 'setLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('errorMessage', 'setErrorMessage', ''),
  withState('newGochiKidFlag', 'setNewGochiKidFlag', 0),
  withState('newGochiKidQrFlag', 'setNewGochiKidQrFlag', 0),
  withState('joinGochiKidFlag', 'setJoinGochiKidFlag', 0)
);

const button = enhance(
  ({
    classes,
    shops,
    open,
    onClose,
    newGochiKidFlag,
    setNewGochiKidFlag,
    newGochiKidQrFlag,
    setNewGochiKidQrFlag,
    openEditProgress,
    updateOpenEditProgress,
    gochiKidFlagEditCheckedList,
    resultMessage,
    setResultMessage,
    errorMessage,
    setErrorMessage,
    gochiKidFlagEditShopAction,
    loading,
    setLoading,
    openProgress,
    updateOpenProgress,
    joinGochiKidFlag,
    setJoinGochiKidFlag,
    openConfirmGochiKidFlag,
    updateOpenConfirmGochiKidFlag,
    openHelpQrUserKid,
    setOpenHelpQrUserKid
  }) => {
    useEffect(() => {
      if (open) {
        setJoinGochiKidFlag(0);
        setNewGochiKidFlag(0);
        setNewGochiKidQrFlag(0);
        if (gochiKidFlagEditCheckedList.length === 1) {
          const oldGochiKidFlag = shops.filter(
            shop => shop.shopId === gochiKidFlagEditCheckedList[0]
          )[0].gochiKidFlag;
          const oldGochiKidQrFlag = shops.filter(
            shop => shop.shopId === gochiKidFlagEditCheckedList[0]
          )[0].gochiKidQrFlag;
          setNewGochiKidFlag(oldGochiKidFlag);
          setNewGochiKidQrFlag(oldGochiKidQrFlag);
          if (oldGochiKidFlag === 0 && oldGochiKidQrFlag === 0) {
            setJoinGochiKidFlag(0);
          } else if (oldGochiKidFlag === 1 && oldGochiKidQrFlag === 1) {
            setJoinGochiKidFlag(1);
          } else if (oldGochiKidFlag === 1 && oldGochiKidQrFlag === 0) {
            setJoinGochiKidFlag(2);
          }
        }
      }
    }, [open, gochiKidFlagEditCheckedList]);

    const handleSubmit = async () => {
      updateOpenEditProgress(false);
      updateOpenConfirmGochiKidFlag(false);
      setLoading(true);
      updateOpenProgress(true);
      const response = await gochiKidFlagEditShopAction(
        newGochiKidFlag,
        newGochiKidQrFlag
      );
      if (response.type === EDIT_GROUP_GOCHI_KID_FLAG_SHOP_SUCCESS) {
        setLoading(false);
        setResultMessage('更新しました。');
      } else {
        setErrorMessage('エラーが発生しました！');
        updateOpenProgress(false);
        setLoading(false);
      }
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
      onClose();
      setResultMessage('');
    };

    const handleChangeJoinGochiKidFlag = value => {
      if (value === 0) {
        setNewGochiKidFlag(0);
        setNewGochiKidQrFlag(0);
      } else if (value === 1) {
        setNewGochiKidFlag(1);
        setNewGochiKidQrFlag(1);
      } else if (value === 2) {
        setNewGochiKidFlag(1);
        setNewGochiKidQrFlag(0);
      }
      setJoinGochiKidFlag(value);
    };

    const handleOpenConfirmDialog = () => {
      if (joinGochiKidFlag === 0) {
        updateOpenEditProgress(true);
      } else if (joinGochiKidFlag === 1) {
        updateOpenConfirmGochiKidFlag(true);
      } else if (joinGochiKidFlag === 2) {
        updateOpenConfirmGochiKidFlag(true);
      }
    };

    return (
      <>
        <Modal open={open} onClose={onClose} className={classes.modal}>
          <div className={classes.contentContainer}>
            <Typography className={classes.title} variant="h6">
              一括こどもごちめし参加設定
            </Typography>
            <FormLabel className={classes.description}>
              チェックした店舗の設定を変更が可能です。
            </FormLabel>
            <FormLabel className={classes.fs14}>
              一括こどもごちめし参加設定*
            </FormLabel>
            <RadioGroup
              row
              value={joinGochiKidFlag}
              onChange={e => {
                handleChangeJoinGochiKidFlag(parseInt(e.target.value, 10));
              }}
              className={classes.radioGroup}
            >
              <FormControlLabel
                value={0}
                control={<Radio color="primary" />}
                label={
                  <Typography style={{ fontWeight: 'bolder' }}>
                    参加しない
                  </Typography>
                }
              />
              <FormControlLabel
                value={1}
                control={<Radio color="primary" />}
                label={
                  <Typography style={{ fontWeight: 'bolder' }}>
                    参加する(カード型会員証対応あり)
                  </Typography>
                }
              />
              <FormControlLabel
                value={2}
                control={<Radio color="primary" />}
                label={
                  <Typography style={{ fontWeight: 'bolder' }}>
                    参加する(カード型会員証対応なし)
                  </Typography>
                }
              />
            </RadioGroup>
            <div style={{ marginBottom: '24px' }}>
              <span className={classes.textHelpTitle}>カード型会員証とは</span>
              <Button
                className={classes.buttonHelp}
                onClick={() => setOpenHelpQrUserKid(true)}
              >
                <HelpIcon className={classes.iconHelpEx} />
              </Button>
            </div>
            <Divider />
            <div className={classes.buttonContainer}>
              <CancelButton onClickAction={onClose} color="primary" />
              <ConfirmButton
                onClickAction={() => {
                  handleOpenConfirmDialog();
                }}
              />
            </div>
          </div>
        </Modal>
        <ConfirmDialog
          openConfirm={openEditProgress}
          updateOpenConfirm={updateOpenEditProgress}
          message="こどもごちめし参加しないように変更しましょうか？"
          okAction={handleSubmit}
        />
        <ProgressDialog
          openProgress={errorMessage !== ''}
          progressOkAction={() => setErrorMessage('')}
          loading={false}
          resultMessage={errorMessage}
        />
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        <ConfirmGochiKidFlagGroupDialog
          openConfirmGochiKidFlag={openConfirmGochiKidFlag}
          updateOpenConfirmGochiKidFlag={updateOpenConfirmGochiKidFlag}
          okAction={handleSubmit}
        />
        <HelpQrUserKidShopDialog
          openHelpQrUserKid={openHelpQrUserKid}
          setOpenHelpQrUserKid={setOpenHelpQrUserKid}
        />
      </>
    );
  }
);

export default withStyles(styles)(button);
